import { Modal } from '@/components/common/Modal'
import { ExternalAssetForm } from '@/components/externalAssets/ExternalAssetForm'

interface AddExternalAssetModalProps {
  open: boolean
  onClose: () => void
}

export function AddExternalAssetModal({ open, onClose }: AddExternalAssetModalProps) {
  return (
    <Modal open={open} onClose={onClose} title="External Asset anlegen">
      <ExternalAssetForm onSuccess={onClose} />
    </Modal>
  )
}
